import React from 'react';

import styles from './RatingItemCleaner.module.scss';
import {rating} from "../../constants/rating";

const RatingItemCleaner = ({handleChangeData, ratingFeature, title}) => {
    return (
        <div className={styles.rating_item}>
            <p>{title} <sup>*</sup></p>

            <div className={styles.rating_item_buttons}>
                {
                    rating.map((item, index) =>
                        <button
                            key={index}
                            type={'button'}
                            onClick={() => handleChangeData(item)}
                            className={`${styles.button} ${ratingFeature === item ? styles.active : ''}`}
                        >{item}</button>)
                }
            </div>
        </div>
    );
};

export default RatingItemCleaner;